<template>
  <div>
    
    <Loading v-if="loading" />
    <div v-if="isAuthenticated">
      <AppHeader />
        <section class="step-progress navbar-space no-padding">
        <div class="container step-container">
          <div class="step-title">
            <h4>การขอออกหนังสือค้ำประกัน LG</h4>
          </div>
        </div>
      </section>

      <section class="personal-info-sc">
              <div class="container">
                  <div class="card card-form">
                    <div
                        class="card-header first-header card-expandable"
                        id="headingOne"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        >
                        <div class="title">
                            
                            <h5 class="mb-0">ตารางงาน(Task List) หนังสือค้ำประกัน LG</h5>
                        </div>
                    </div>
                    <div class="card-body compact-padding">
                        <div class="compact-padding">
                            <div class="form-row">
                                <div class="form-group col-md-5">
                                    <label>หมายเลขบัตรประชาชน (Tax ID)</label>
                                    <b-form-input
                                    v-model="requesterTaxId"
                                    name="requesterTaxId"
                                    type="text"
                                    maxlength=13
                                    onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                    ></b-form-input>
                                </div>
                                <div class="form-group col-md-5">
                                    <label>ชื่อลูกค้า (วางค้ำประกันในนาม)</label>
                                    <input
                                    v-model="requesterNameTh"
                                    name="requesterNameTh"
                                    type="text"
                                    class="form-control"
                                    
                                    >
                                </div>
                            </div>

                            <div class="form-row div-valign">
                                <div class="form-group no-label col-md-5">
                                    <div class="form-row">
                                    <label>&nbsp;วันที่เริ่มค้ำประกัน    ตั้งแต่วันที่ &nbsp;</label>
                                    <date-picker
                                        v-model="periodStartDate"
                                        name="periodStartDate"
                                        ref="periodStartDate"
                                        lang="th"
                                        format="DD/MM/YYYY"
                                        data-vv-as="ตั้งแต่วันที่"
                                        @change="clearPeriodEndDate()"
                                    ></date-picker>
                                    </div>
                                </div>         
                                <div class="form-group no-label col-md-5">
                                    <div class="form-row">
                                    <label>&nbsp;ถึงวันที่ &nbsp;</label>
                                    <date-picker
                                        v-model="periodEndDate"
                                        name="periodEndDate"
                                        ref="periodEndDate"
                                        lang="th"
                                        format="DD/MM/YYYY"
                                        data-vv-as="ถึงวันที่"
                                        :not-before="this.periodStartDate"
                                    ></date-picker>
                                    </div>
                                </div>              
                            </div>

                            <div class="form-row div-valign">
                                <div class="form-group no-label col-md-3" align="right">
                                    <label></label>
                                    
                                </div> 
                                <div class="form-group no-label col-md-2" align="right">
                                    <label></label>
                                    
                                </div> 
                                <div class="form-group no-label col-md-5">
                                    <label></label>
                                    <button
                                        class="btn btn-lg btn-primary-ktb"
                                        type="button"
                                        @click="getLgList(1)"
                                    >
                                        ค้นหารายการ
                                    </button>&nbsp;&nbsp;
                                    <button
                                        class="btn btn-lg btn-primary-ktb"
                                        type="button"
                                        @click="clearCriteria()"
                                    >
                                        ล้างข้อมูล
                                    </button>&nbsp;&nbsp;
                                    <button
                                        class="btn btn-lg btn-primary-ktb"
                                        type="button"
                                        @click="exportExcel()"
                                    >
                                        Report as Excel
                                    </button>
                                </div>       
                                              
                            </div>
                        </div>
                    </div>
                    <div
                        class="card-header first-header card-expandable"
                        id="headingOne"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        >
                        <div class="title">
                            <h5 class="mb-0">รายละเอียดหนังสือค้ำประกัน LG</h5>
                        </div>
                    </div>


                    <div v-if="taskList !=null && taskList.length > 0" class="row justify-content-center">
            <div class="col-12 col-xs-fix compact-padding" ><br>
              <div class="purchase-table-wrapper table-wrapper">
                <table class="purchase-table table">
                  <thead>
                    <tr>

                      <th scope="col">Tax ID<br>ของผู้ออกในนาม</th>
                      <th scope="col">วันที่อนุมัติรายการ<br>หนังสือค้ำประกัน</th>    
                      <th scope="col">ชื่อเจ้าของวงเงิน</th>
                      <th scope="col">เพื่อค้ำประกันในนาม</th>
                      <th scope="col">ผู้รับผลประโยชน์<br>(ผู้รับหนังสือค้ำประกัน)</th>
                      <th scope="col">ประเภทค้ำประกัน</th>
                      <th scope="col">สัญญาลงวันที่</th>
                      <th scope="col">วงเงินค้ำประกัน</th>
                      <th scope="col">ระยะเวลา<br>ค้ำประกัน</th>
                      <th scope="col">วันที่เริ่มค้ำประกัน</th> 
                      <th scope="col">วันสิ้นสุดค้ำประกัน</th>
                      <th scope="col">เลขที่หนังสือค้ำประกัน</th>
                      <th scope="col">สถานะรายการ</th>
                      <th scope="col">รหัสสถานบริการ<br>(H Code)</th>
                      <th scope="col">ดาวน์โหลด<br>หนังสือค้ำประกัน</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="main-row"
                      v-for="(item, index) in taskList"
                      v-bind:item="item"
                      v-bind:index="index"
                      v-bind:key="[item.appId,item.requesterTaxId]"
                    >
                      <td class="name-cell">{{item.requesterTaxId}} </td>
                      <td class="name-cell">{{item.approveDate}}</td>
                      <td class="name-cell">{{item.customerName}}</td>
                      <td class="name-cell">{{item.requesterNameTh}}</td>
                      <td class="name-cell">{{item.beneficiaryNameTh}}</td>
                      <td class="name-cell">{{item.contingentTypeName}}</td>
                      <td class="name-cell">{{item.contractDate}}</td>
                      <td class="name-cell">{{item.lgAmt}}</td>
                      <td class="name-cell">{{item.periodDesc}}</td>
                      <td class="name-cell">{{item.lgEffectiveDate}}</td> 
                      <td class="name-cell">{{item.lgExpireDate}}</td>
                      <td class="name-cell">{{item.contingentNo}}</td>
                      <td class="name-cell">{{item.requestTypeDesc}}</td>
                      <td class="name-cell">{{item.hospitalCode}}</td>
                      <td v-if="item.subFormTemplate01!=''">                        
                          <input
                            slot="actions"
                            type="button"
                            class="btn btn-info"
                            value="Download"
                            @click="downloadPdf(item.appId);"
                        ></td>
                      <td v-else></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <label>Showing {{this.startItem}} to {{this.endItem}} of {{this.totalRecord}} entries&nbsp;&nbsp;&nbsp;&nbsp;</label>
            <b-pagination
              size="md"
              :total-rows="totalRecord"
              v-model="currentPage"
              :per-page="20"
              @input="getLgList(currentPage)"
            ></b-pagination>
          </div>

<div v-if="taskList ===null || taskList.length == 0" class="row justify-content-center">
            <div class="col-12 col-xs-fix">
              <div class="purchase-table-wrapper table-wrapper">
                <table class="purchase-table table">
                  <thead>
                    <tr>
                      <th scope="col">Tax ID<br>ของผู้ออกในนาม</th>
                      <th scope="col">วันที่อนุมัติรายการ<br>หนังสือค้ำประกัน</th>    
                      <th scope="col">ชื่อเจ้าของวงเงิน</th>
                      <th scope="col">เพื่อค้ำประกันในนาม</th>
                      <th scope="col">ผู้รับผลประโยชน์<br>(ผู้รับหนังสือค้ำประกัน)</th>
                      <th scope="col">ประเภทค้ำประกัน</th>
                      <th scope="col">สัญญาลงวันที่</th>
                      <th scope="col">วงเงินค้ำประกัน</th>
                      <th scope="col">ระยะเวลา<br>ค้ำประกัน</th>
                      <th scope="col">วันที่เริ่มค้ำประกัน</th> 
                      <th scope="col">วันสิ้นสุดค้ำประกัน</th>
                      <th scope="col">เลขที่หนังสือค้ำประกัน</th>
                      <th scope="col">สถานะรายการ</th>
                      <th scope="col">รหัสสถานบริการ<br>(H Code)</th>
                      <th scope="col">ดาวน์โหลด<br>หนังสือค้ำประกัน</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="empty-data">
                      <td colspan="999">ไม่พบข้อมูล</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
                  </div>
              
            
         </div>
        
      </section>
     
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppFooter from "../pagecomp/appFooter";
import AppHeader from "../pagecomp/appHeader";
import { mapGetters } from "vuex";
import { apiClient } from "@/utils/apiClient";
import moment from "moment";
//import DatePicker from "vue2-datepicker";
import DatePicker from "@/resources/datepicker/vue2-datepicker";

export default {
components: {
    AppFooter,
    AppHeader,
    DatePicker,
    moment
  },
  name: "TaskList",

  data() {
    return {
      requesterTaxId:"",
      requesterNameTh:"",
      periodStartDate:moment(moment(new Date())).subtract(1,'months').format('YYYY-MM-DD'),
      periodEndDate:"",
      taskList: [
        {
          taskId: "",
          requestId: ""
        }
      ],
      currentPage: 1,
      limitPage: 20,
      totalRecord: 0,
      startItem:1,
      endItem:20,
      taskVo: null,
      selected: [],
      appId: "",
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "authStatus"]),
    loading: function() {
      return this.authStatus === "loading" && !this.isAuthenticated;
    }
  },
  methods: {

    getLgList: function(currentPage) {
        this.loader = this.$loading.show();

        let vperiodStartDate = "";
        let vperiodEndDate = "";
        vperiodStartDate = moment(this.periodStartDate).format("YYYY-MM-DD");
        vperiodEndDate = moment(this.periodEndDate).format("YYYY-MM-DD");       

        if (vperiodStartDate == "Invalid date") {
            vperiodStartDate = "";
        }
        if (vperiodEndDate == "Invalid date") {
            vperiodEndDate = "";
        }
        console.log("getLgList this.requesterTaxId = "+this.requesterTaxId);
        console.log("getLgList this.requesterNameTh = "+this.requesterNameTh);
        console.log("getLgList vperiodStartDate = "+vperiodStartDate);
        console.log("getLgList vperiodEndDate = "+vperiodEndDate);
        apiClient
        .get("/api/task/getLgList/" + currentPage + "/" + this.limitPage,
        {params: {
                    'requesterTaxId' : this.requesterTaxId,
                    'requesterNameTh' : this.requesterNameTh,
                    'periodStartDate' : vperiodStartDate,
                    'periodEndDate' : vperiodEndDate
                }
        }
        )
        .then(resp => {
          this.taskList = resp.data.list;
          this.data = resp.data.list;
          this.totalRecord = resp.data.fullListSize;
          this.startItem = resp.data.startItem;
          this.endItem = resp.data.endItem;
          this.loader.hide();
          window.scrollTo(0, 0);
        })
        .catch(err => {
          this.loader.hide();
          this.$swal("Error!", "" + err, "error");
        });
    },
    clearCriteria: function(){
        this.requesterTaxId = "";
        this.requesterNameTh = "";
        this.periodStartDate = "";
        this.periodEndDate = "";
    },
    clearPeriodEndDate: function(){
        this.periodEndDate = "";
    },
    exportExcel: function() {
        this.loader = this.$loading.show();

        let vperiodStartDate = "";
        let vperiodEndDate = "";
        vperiodStartDate = moment(this.periodStartDate).format("YYYY-MM-DD");
        vperiodEndDate = moment(this.periodEndDate).format("YYYY-MM-DD");       

        if (vperiodStartDate == "Invalid date") {
            vperiodStartDate = "";
        }
        if (vperiodEndDate == "Invalid date") {
            vperiodEndDate = "";
        }

        console.log("exportExcel this.requesterTaxId = "+this.requesterTaxId);
        console.log("exportExcel this.requesterNameTh = "+this.requesterNameTh);
        console.log("exportExcel vperiodStartDate = "+vperiodStartDate);
        console.log("exportExcel vperiodEndDate = "+vperiodEndDate);

        apiClient
        .post("/api/task/getLgExportExcel",
        {
                    requesterTaxId : this.requesterTaxId,
                    requesterNameTh : this.requesterNameTh,
                    periodStartDate : vperiodStartDate,
                    periodEndDate : vperiodEndDate
                }
        ,{responseType: 'arraybuffer'} 
        )
        .then(resp => {
            const url = URL.createObjectURL(new Blob([resp.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }))
            console.log("url"+url);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "REPORT.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loader.hide();
        })
        .catch(err => {
          this.loader.hide();
          this.$swal("Error!", "" + err, "error");
        });
    },
    downloadPdf :function(appId) {
      this.loader = this.$loading.show();
      apiClient
        .get("/api/task/getLgDocPdf/" + appId ,{responseType: 'blob'})
        .then(resp => {
            const file = new Blob([resp.data], {type: 'application/pdf'});
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            window.open(fileURL);
            this.loader.hide();
        })
        .catch(err => {
          this.loader.hide();
          this.$swal("Error!", "" + err, "error");
        });

    }
  },
  mounted() {
    this.getLgList(this.currentPage);
  }
};
</script>